<template>
    <div class="example-box">
        <div class="activity">
        <!-- 背景图片 -->
        <div class="activity-bg">
            <img :src="mixinQiniuImg('/activity_bg.png')">
        </div>
        <!-- 主要内容区域 -->
        <div class="activity-content" :style="{ backgroundImage: `url(${mixinQiniuImg('/activity_content_bg.png')})` }">
            <!-- 标题区域 -->
            <div class="title-section">
                <img :src="mixinQiniuImg('/activity_xhb.png')">
                <div class="title-text">{{ activityInfo.name }}</div>
            </div>
            <!-- 红包卡片区域 -->
            <div class="red-packet-section">
                <div class="red-packet-item" v-for="i in 3" :key="i">
                    <img :src="mixinQiniuImg('/activity_hb.png')">
                </div>
            </div>
            <!-- 领取按钮 -->
            <div class="receive-section" :style="{ backgroundImage: `url(${mixinQiniuImg('/activity_btn.png')})` }">
                <span class="btn-text">立即领取</span>
            </div>
        </div>
        <!-- 活动介绍 -->
        <div class="activity-info">
            <div class="info-title-bg">
                <img :src="mixinQiniuImg('/activity_titlebg.png')">
            </div>
            <div class="info-title">
                <img :src="mixinQiniuImg('/activity_icon.png')">
                <span>活动介绍</span>
                <img :src="mixinQiniuImg('/activity_icon.png')">
            </div>
            <div class="info-content">
                <div class="info-item">
                    <span class="info-label">活动时间：</span>
                    <span class="info-value">{{ activityInfo.time }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">活动玩法：</span>
                    <span class="info-value">{{ activityInfo.rule }}</span>
                </div>
                <div class="info-item">
                    <span class="info-label">活动说明：</span>
                    <span class="info-value">{{ activityInfo.description }}</span>
                </div>
            </div>
        </div>
    </div>
    
    <div class="iphone-box"></div>
    </div>

</template>

<script>
export default {
    props: {
        activityInfo: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>

<style scoped>
.example-box{
    width: 375px;
    position: relative;
    padding: 16px;
    box-sizing: content-box;
}
.iphone-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    background-image: url('../../../assets/img/iphone.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

/**
 * 活动页面主容器
 */
.activity {
    width: 375px;
    position: relative;
    background: #BBECF9;
    padding: 272px 0 16px;
    border-radius: 44px;
    overflow: hidden;
}


/**
 * 背景图片容器
 */
.activity-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 445px;
    z-index: 1;
}

.activity-bg img {
    width: 100%;
    height: 100%;
}

/**
 * 主要内容区域
 */
.activity-content {
    position: relative;
    z-index: 2;
    box-sizing: border-box;
    width: 343px;
    margin: 0 auto;
    padding: 12px 16px;
    box-sizing: border-box;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

/**
 * 标题区域样式
 */
.title-section {
    display: flex;
    align-items: center;
}

.title-section img {
    width: 31px;
    height: 31px;
}

.title-text {
    width: 100%;
    height: 22px;
    font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
    font-weight: bold;
    font-size: 18px;
    color: #BC1300;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    position: relative;
    z-index: 10;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


/**
 * 红包卡片区域
 */
.red-packet-section {
    margin-top: 17px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.red-packet-item {
    position: relative;
    width: 90px;
    height: 114px;
}


.red-packet-item img {
    width: 100%;
    height: 100%;
}



/**
 * 领取按钮区域
 */
.receive-section {
    position: relative;
    width: 180px;
    height: 70px;
    margin: 22px auto 0;
    text-align: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.btn-text {
    position: relative;
    top: 17px;
    z-index: 2;
    height: 24px;
    line-height: 24px;
    font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
    font-weight: bold;
    font-size: 20px;
    color: transparent;
    text-align: center;
    font-style: normal;
    background: linear-gradient(0deg, #FFF7EF 0%, #FFF9F1 20%, #FFFAF1 58%, #FFF7EC 87%, #FFFCF8 100%);
    -webkit-background-clip: text;
    background-clip: text;
}

/**
 * 活动介绍区域
 */
.activity-info {
    width: 343px;
    background: rgba(255, 255, 255, 0.62);
    box-shadow: 0px 2px 5px 0px #D8F0F7;
    border-radius: 12px;
    backdrop-filter: blur(9px);
    margin: 15px auto;
    position: relative;
    z-index: 2;
    padding: 16px 28px 24px;
    box-sizing: border-box;
}

.info-title-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 343px;
    height: 88px;
}

.info-title-bg img {
    width: 100%;
    height: 100%;
}

.info-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-family: CKTKingKong;
    font-size: 20px;
    color: #333333;
    line-height: 27px;
    text-align: right;
    font-style: normal;
}

.info-title img {
    width: 20px;
    height: 20px;
}

.info-content {
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    text-align: left;
    font-style: normal;
}

.info-item {
    display: flex;
    align-items: flex-start;
    margin-top: 12px;
}

.info-item:first-child {
    margin-top: 16px;
}

.info-label {
    white-space: nowrap;
}

.info-value {
    word-break: break-word;
    /* 允许在单词内换行 */
    word-wrap: break-word;
    /* 允许长单词换行 */
}
</style>